// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".delete2--ypfhE{object-fit:contain}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/Delete2/index.module.scss"],"names":[],"mappings":"AAAA,gBAAS,kBAAkB","sourcesContent":[".delete2{object-fit:contain}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"delete2": "delete2--ypfhE"
};
export default ___CSS_LOADER_EXPORT___;
